export default __webpack_public_path__ + "fonts/CiscoSansHeavy-webfont.eot";